export enum UIEvent {
    AUTO_SPIN = 'onUIAutoSpin',

    BET_QUANTITY_UP = 'onBetQuantityUp',
    BET_QUANTITY_DOWN = 'onBetQuantityDown',
    BET_QUANTITY_MAX = 'onBetQuantityMax',

    COIN_VALUE_UP = 'onCoinValueUp',
    COIN_VALUE_DOWN = 'onCoinValueDown',
    COIN_VALUE_MAX = 'onCoinValueMax',

    BET_UP = 'onUIBetUp',
    BET_DOWN = 'onUIBetDown',
    BET_SELECT = 'onUIBetSelect',

    GAME_SPEED_LEVEL_UP = 'onUIGameSpeedLevelUp',
    GAME_SPEED_LEVEL_DOWN = 'onUIGameSpeedLevelDown',
}
